import type { ReactNode } from 'react';
import { CopyableCell } from '@/shared/ui';

/** Как ячейка показывает своё значение */
type CopyableCellOptions = {
  /**
   * Значение переносится по строкам ширины колонки, а не усекается. Колонке при этом нужен и
   * `wrap` грида: перенос, не объявленный самим содержимым, усечёт обёртка ячейки.
   */
  isContentWrapped?: boolean;
};

/** Ячейка с кнопкой копирования показанного значения; без текста кнопка не рисуется */
export const renderCopyableCell = (
  text: string | null,
  content: ReactNode,
  { isContentWrapped }: CopyableCellOptions = {},
) => (
  <CopyableCell text={text} isContentWrapped={isContentWrapped}>
    {content}
  </CopyableCell>
);
